import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import { getSrc } from "gatsby-plugin-image"

const SEO = ({ title, description, image, article }) => {
  const { pathname } = useLocation()
  const data = useStaticQuery(graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: siteUrl
        }
      }
      defaultImage: file(relativePath: { eq: "backgrounds/home-hero-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1920
            placeholder: TRACED_SVG
          )
        }
      }
    }
  `)

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
  } = data.site.siteMetadata

  const defaultImage = getSrc(data.defaultImage)

  const SEO = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  }

  return (
    <Helmet title={SEO.title} titleTemplate={titleTemplate}>
      <meta name="description" content={SEO.description} />
      <meta name="image" content={SEO.image} />

      {SEO.url && <meta property="og:url" content={SEO.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {SEO.title && <meta property="og:title" content={SEO.title} />}

      {SEO.description && (
        <meta property="og:description" content={SEO.description} />
      )}

      {SEO.image && <meta property="og:image" content={SEO.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {SEO.title && <meta name="twitter:title" content={SEO.title} />}

      {SEO.description && (
        <meta name="twitter:description" content={SEO.description} />
      )}

      {SEO.image && <meta name="twitter:image" content={SEO.image} />}

      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "https://www.831b.com",
            "name": "SRA 831(b) ADMIN",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "208-424-2249",
              "contactType": "Customer Support"
            }
          }
        `}
      </script>
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
}